export const PASSWORD_CHANGE = 'PASSWORD_CHANGE';

export const passwordChange = password => ({
  ...password,
  editing: 'password',
  saving: true,
  type: PASSWORD_CHANGE,
});

export default {
  passwordChange,
};
